import React, { useEffect, useRef, useState } from 'react';

import IconButton from 'components/core/IconButton';
import { MoreVerticalIcon } from 'components/Icons';

import { StyledItem, StyledMenu, StyledWrapper } from './DropdownMenu.styles';
import { TDropdownMenuProps } from './DropdownMenu.types';

const DropdownMenu = ({
  items,
  ariaLabel = 'More actions',
  trigger,
  className,
}: TDropdownMenuProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!isOpen) {
      return undefined;
    }
    const handleClickOutside = (event: MouseEvent) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    const handleKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleKey);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleKey);
    };
  }, [isOpen]);

  return (
    <StyledWrapper ref={wrapperRef} className={className}>
      <IconButton aria-label={ariaLabel} onClick={() => setIsOpen((prev) => !prev)}>
        {trigger ?? <MoreVerticalIcon size={18} />}
      </IconButton>
      {isOpen ? (
        <StyledMenu role="menu">
          {items.map((item) => (
            <StyledItem
              key={item.label}
              type="button"
              role="menuitem"
              danger={item.danger}
              onClick={() => {
                setIsOpen(false);
                item.onClick();
              }}>
              {item.label}
            </StyledItem>
          ))}
        </StyledMenu>
      ) : null}
    </StyledWrapper>
  );
};

export default DropdownMenu;
